<layout-config-accordion *ngIf="!!layoutConfig" [layoutConfig]="layoutConfig"> </layout-config-accordion>
